// extracted by mini-css-extract-plugin
export default {"cls1":"PaperSelector-cls1_VcC","cls2":"PaperSelector-cls2_j64 PaperSelector-cls1_VcC"};